export const regions = [
  // US
  { RegionCode: "us-east-1", RegionName: "US East (N. Virginia)" },
  { RegionCode: "us-east-2", RegionName: "US East (Ohio)" },
  { RegionCode: "us-west-1", RegionName: "US West (N. California)" },
  { RegionCode: "us-west-2", RegionName: "US West (Oregon)" },
  // AFRICA
  { RegionCode: "af-south-1", RegionName: "Africa (Capetown)" },
  // ASIA PACIFIC
  { RegionCode: "ap-east-1", RegionName: "Asia Pacific (Hong Kong)" },
  { RegionCode: "ap-southeast-3", RegionName: "Asia Pacific (Jakarta)" },
  { RegionCode: "ap-south-1", RegionName: "Asia Pacific (Mumbai)" },
  { RegionCode: "ap-northeast-3", RegionName: "Asia Pacific (Osaka)" },
  { RegionCode: "ap-northeast-2", RegionName: "Asia Pacific (Seoul)" },
  { RegionCode: "ap-southeast-1", RegionName: "Asia Pacific (Singapore)" },
  { RegionCode: "ap-southeast-2", RegionName: "Asia Pacific (Sydney)" },
  { RegionCode: "ap-northeast-1", RegionName: "Asia Pacific (Tokyo)" },
  // CANADA
  { RegionCode: "ca-central-1", RegionName: "Canada (Central)" },
  // EUROPE
  { RegionCode: "eu-central-1", RegionName: "Europe (Frankfurt)" },
  { RegionCode: "eu-west-1", RegionName: "Europe (Ireland)" },
  { RegionCode: "eu-west-2", RegionName: "Europe (London)" },
  { RegionCode: "eu-south-1", RegionName: "Europe (Milan)" },
  { RegionCode: "eu-west-3", RegionName: "Europe (Paris)" },
  { RegionCode: "eu-north-1", RegionName: "Europe (Stockholm)" },
  // MIDDLE EAST
  { RegionCode: "me-south-1", RegionName: "Middle East (Bahrain)" },
  { RegionCode: "me-central-1", RegionName: "Middle East (UAE)" },
  // SOUTH AMERICA
  { RegionCode: "sa-east-1", RegionName: "South America (S\u00e3o Paulo)" },
];
